import React, { Component } from "react";
import SentenceTrendsIndicatorOld from "./SentenceTrendsIndicator";
import { CATEGORY_IDS } from "./categoryPriority";
import { endsWithS, slashSeparatedArea } from "./localHelpers";

const SENTENCE_TRENDS_METRICS_STRIP_URL =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/042326_dashboard_graphic_1.png";

class SentenceTrendsBodyOld extends Component {
  createBottomLine = (cityOrArea) => {
    const { hoData, sentences } = this.props;
    const { subdivisionName } = hoData;
    const { mlsNeighborhood, mlsCityName, mlsAreaID } = this.props.currentArea;
    const benefitsCount = sentences.filter(
      (s) => s.benefit === "Seller's",
    ).length;

    let place;
    if (mlsAreaID === "ALA-2619I") {
      place = "Maxwell Park";
    } else if (subdivisionName && subdivisionName.length > 1) {
      place = subdivisionName;
    } else if (cityOrArea === "city") {
      place = mlsCityName;
    } else if (cityOrArea === "area") {
      if (mlsAreaID === "SBA-20FInv" || mlsAreaID === "SBA-20FRes") {
        place = "Downtown";
      } else if (
        (mlsNeighborhood && mlsNeighborhood.length > 21) ||
        mlsAreaID === "SCL-16J" ||
        mlsAreaID === "SMA-390" ||
        mlsAreaID === "ALA-3900AK"
      ) {
        place = "your neighborhood";
      } else {
        place = slashSeparatedArea(mlsNeighborhood);
      }
    }

    if (benefitsCount === 3) {
      return `All three market indicators above show that ${place} continues to be a strong seller’s market.`;
    }
    if (benefitsCount === 2) {
      return `With strategically priced homes, the market trends above clearly indicate that ${place} continues to favor sellers.`;
    }
    if (benefitsCount === 1) {
      return ` As the market becomes more price-sensitive, well-priced homes are still attracting strong offers, making accurate pricing and presentation more important than ever.`;
    }
    if (benefitsCount === 0) {
      return `As the market becomes more price-sensitive, well-priced homes are still attracting strong offers, making accurate pricing and strategic presentation more important than ever.`;
    }
    return "";
  };

  formatAreaName = () => {
    const { mlsNeighborhood, mlsAreaID } = this.props.currentArea;
    const { subdivisionName } = this.props.hoData;

    if (subdivisionName) {
      return subdivisionName;
    }
    if (mlsAreaID === "SCL-16J") {
      return "Your Neighborhood";
    }
    if (mlsAreaID === "SMA-392") {
      return "Isle Cove - Neighborhood 9, Foster City";
    }
    if (mlsAreaID === "SMA-398") {
      return "Treasure Isle - Neighborhood 1, Foster City";
    }
    if (mlsAreaID === "SMA-390") {
      return "Sea Colony - Neighborhood 7, Foster City";
    }
    if (mlsNeighborhood && mlsNeighborhood.length > 28) {
      return "Your Neighborhood";
    }
    return mlsNeighborhood;
  };

  getTitleStyles = () => {
    const { mlsAreaID } = this.props.currentArea;

    return "";
  };

  render() {
    const { formatAreaName } = this;
    const { sentences, cityOrArea, agentData, currentArea } = this.props;
    const { mlsAreaID } = currentArea;
    const { listgenUserID } = agentData;

    const titleStyles = this.getTitleStyles();
    let showBottomLine = true;

    let bottomLineStyles;

    let dbIndicatorContainerStyles;

    const sentencesForDisplay = (() => {
      const list = [...sentences];
      const averageSalePrice = list.filter(
        (s) => s.categoryId === CATEGORY_IDS.AVERAGE_HOME_PRICE,
      );
      const rest = list.filter(
        (s) => s.categoryId !== CATEGORY_IDS.AVERAGE_HOME_PRICE,
      );
      const sellerRest = rest.filter((s) => s.benefit === "Seller's");
      const nonSellerRest = rest.filter((s) => s.benefit !== "Seller's");
      return [...averageSalePrice, ...sellerRest, ...nonSellerRest];
    })();

    return (
      <div className="sentence-trends-db-body-old">
        <div className="sentence-trends-db-body-header-old">
          <p className={`sentence-trends-db-body-header-title-old ${titleStyles}`}>
            {formatAreaName()}
          </p>
        </div>

        <div className="sentence-trends-metrics-strip-wrap-old">
          <img
            src={SENTENCE_TRENDS_METRICS_STRIP_URL}
            alt=""
            className="sentence-trends-metrics-strip-img-old"
          />
        </div>

        <div
          className={`sentence-trends-indicator-container-old ${dbIndicatorContainerStyles}`}
        >
          {sentencesForDisplay.map((sentence, index) => (
            <SentenceTrendsIndicatorOld
              key={`${sentence.header}-${index}`}
              header={sentence.header}
              logic={sentence.logic}
              statement={sentence.statement}
              benefit={sentence.benefit}
              index={index + 1}
              listgenUserID={listgenUserID}
              mlsAreaID={mlsAreaID}
            />
          ))}
        </div>
        {showBottomLine && (
          <div className={`sentence-trends-bottom-line-old ${bottomLineStyles}`}>
            <div className="sentence-trends-bottom-line-title-old">Take Away:</div>{" "}
            <div className="sentence-trends-bottom-line-text-old">
              {this.createBottomLine(cityOrArea)}{" "}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SentenceTrendsBodyOld;
